import { Suspense } from "react";
import Carousel from "app/components/Carousel";
import { BlogCard } from "app/components/Blog/BlogCard";
import CardSkeleton from "app/components/Home/CardSkeleton";
import type { BlogCardProps } from "app/routes/Blogs._index/interface";

interface BlogSectionProps {
  blogs: any;
  isBlogLoading: boolean;
  isBlogSuccess: boolean;
}

export function BlogSection({ blogs, isBlogLoading, isBlogSuccess }: BlogSectionProps) {
  return (
    <section className="mb-20 md:px-4 xl:px-12 2xl:px-20 w-full flex flex-col gap-2 md:space-y-6 w-max-ppn">
      <h4 className="space-y-2">
        <div className="font-bold text-2xl text-foreground capitalize text-center">
          Our Blog
        </div>
        <div className="text-lg text-gray dark:text-gray-200 text-center">
          Browse Our Latest News
        </div>
      </h4>

      {/* Desktop Carousel */}
      <div className="hidden md:block max-h-[30rem]">
        <Carousel numberOfItems={3}>
          {isBlogSuccess && blogs?.data?.payload?.data && !isBlogLoading
            ? blogs.data.payload.data.map((post: BlogCardProps) => (
                <div
                  key={post?._id}
                  className="flex flex-col md:flex-row gap-1 sm:mx-2 md:mx-1 bg-transparent"
                >
                  <BlogCard
                    title={post?.title}
                    summary={post?.summary}
                    slug={post?.slug || post?.title}
                    description={post?.description}
                    imageSrc={post?.imageSrc}
                    _id={post?._id}
                    category={post?.category}
                    body={post?.body}
                  />
                </div>
              ))
            : Array.from({ length: 3 }).map((_, v) => (
                <div
                  key={v}
                  className={`"flex flex-col items-center justify-center md:flex-row gap-1 sm:mx-2 md:mx-1 bg-transparent min-w-80`}
                >
                  <CardSkeleton />
                </div>
              ))}
        </Carousel>
      </div>

      {/* Mobile Grid */}
      <div className="block md:hidden p-3">
        {isBlogSuccess && blogs?.data?.payload?.data && !isBlogLoading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:mx-2 md:mx-1 mb-4">
            {blogs.data.payload.data.map((post: BlogCardProps) => (
              <BlogCard
                key={`mobile_${post?._id}`}
                title={post?.title}
                summary={post?.summary}
                slug={post?.slug || post?.title}
                description={post?.description}
                imageSrc={post?.imageSrc}
                _id={post?._id}
                category={post?.category}
                body={post?.body}
              />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 sm:mx-2 md:mx-1 mb-4">
            <CardSkeleton />
          </div>
        )}
      </div>
    </section>
  );
}
